module.exports = __webpack_public_path__ + "static/media/window-image.46d28fa5.png";